import React, { RefObject, useRef } from 'react';
import { useDateRangeValidation } from './useDateRangeValidation';
import { Row } from '../../grid/Row/Row';
import { Input } from '../Input/Input';

type BasicControlledRange = {
  start: any;
  end: any;
  labelStart: string;
  labelEnd: string;
  onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  onChange?: (event: React.FocusEvent<HTMLInputElement, Element>) => void;
  dateRangeTypeDependentValidation?: (
    startRef: RefObject<HTMLInputElement | null>,
    endRef: RefObject<HTMLInputElement | null>
  ) => void;
};

const getValueForDateType = (type: 'date' | 'datetime' | 'datetime-local' | 'time' | undefined, value?: string) => {
  return type === 'date' ? value?.split('T')[0] : value;
};

/**
 * Date Range to switch between date-time and datetime-local types.
 *
 * value here is always given in datetime-local format from BE.
 * TODO: need to keep time somewhere in state so we dont lose input while switching.
 */
export function BasicControlledRange({
  labelStart,
  labelEnd,
  start,
  end,
  onBlur,
  onChange,
  dateRangeTypeDependentValidation,
}: BasicControlledRange) {
  const startRef = useRef<HTMLInputElement>(null);
  const endRef = useRef<HTMLInputElement>(null);

  const validation = useDateRangeValidation(startRef, endRef, dateRangeTypeDependentValidation);

  return (
    <Row modifier="row--grid-2-columns">
      <Input
        label={labelStart}
        param={start}
        ref={startRef}
        onBlur={typeof onBlur === 'function' ? onBlur : undefined}
        value={getValueForDateType(start?.type, start?.value)}
        onChange={onChange}
      />
      <Input
        label={labelEnd}
        param={end}
        ref={endRef}
        onBlur={validation}
        value={getValueForDateType(end?.type, end?.value)}
        onChange={onChange}
      />
    </Row>
  );
}
